/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Are_You_SureInputs */

const en_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

const fr_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr ?`)
};

const de_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher?`)
};

const it_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro?`)
};

const ru_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены?`)
};

const es_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Está seguro?`)
};

const zh_cn2_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你确定吗？`)
};

const ja_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本気ですか？`)
};

const hi_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आपको यकीन है?`)
};

const pt_pt2_are_you_sure = /** @type {(inputs: Are_You_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Are_You_SureInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const are_you_sure = /** @type {((inputs?: Are_You_SureInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Are_You_SureInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_are_you_sure(inputs)
	if (locale === "de") return de_are_you_sure(inputs)
	if (locale === "it") return it_are_you_sure(inputs)
	if (locale === "ru") return ru_are_you_sure(inputs)
	if (locale === "es") return es_are_you_sure(inputs)
	if (locale === "zh-CN") return zh_cn2_are_you_sure(inputs)
	if (locale === "ja") return ja_are_you_sure(inputs)
	if (locale === "hi") return hi_are_you_sure(inputs)
	if (locale === "pt-PT") return pt_pt2_are_you_sure(inputs)
	return en_are_you_sure(inputs)
});